import React from 'react';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';

interface YesNoRadioProps {
  name: string;
  value: boolean | null;
  onChange: (value: boolean | null) => void;
  includeUnknownOption?: boolean;
  unknownLabel?: string;
}

export const YesNoRadio: React.FC<YesNoRadioProps> = ({
  name,
  value,
  onChange,
  includeUnknownOption = false,
  unknownLabel,
}) => {
  const { t } = useTranslation('Patient');

  const options: {
    label: string;
    checked: boolean;
    setTo: boolean | null;
  }[] = [
    { label: t('yes'), checked: value === true, setTo: true },
    { label: t('no'), checked: value === false, setTo: false },
  ];

  if (includeUnknownOption) {
    options.push({
      label: unknownLabel || t('notProvided'),
      checked: value === null,
      setTo: null,
    });
  }

  return (
    <div
      role="radiogroup"
      aria-label={name}
      className="inline-flex rounded-lg border border-slate-300 bg-white p-0.5 dark:border-gray-600 dark:bg-gray-800"
    >
      {options.map((opt) => (
        <button
          key={opt.label}
          type="button"
          role="radio"
          aria-checked={opt.checked}
          onClick={() =>
            onChange(opt.checked && !includeUnknownOption ? null : opt.setTo)
          }
          className={cn(
            'rounded-md px-4 py-1.5 text-sm font-medium transition-colors',
            opt.checked
              ? 'bg-blue-500 text-white shadow-sm'
              : 'text-title-page-color-300 hover:bg-slate-100 dark:text-gray-300 dark:hover:bg-gray-700/60'
          )}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
};
